import { Col, Image, Row, Typography } from "antd"
import PropTypes from "prop-types"
import React from "react"
import styled from "styled-components"

// ----------------------------------------------------------------------------

function _RoomCard(props) {
    // -------------------------------------
    // Props destructuring
    // -------------------------------------

    const { className, imageSrc, options, id, allocateRoom, selected } = props

    const settings = {
        dots: true,
        infinite: false,
        speed: 300,
        slidesToShow: 1,
        arrows: true,
    }

    const { Text, Title } = Typography

    // -------------------------------------
    // Hooks (e.g. useState, useMemo ...)
    // -------------------------------------

    // -------------------------------------
    // Effects
    // -------------------------------------

    // -------------------------------------
    // Component functions
    // -------------------------------------

    function Mates() {
        if (options.mates) {
            return <span className="info">{options.mates} coinquilini</span>
        }
        return <></>
    }

    function Rooms() {
        if (options.rooms) {
            return <span className="info">{options.rooms} camere</span>
        }
        return <></>
    }

    function Bathrooms() {
        if (options.bathrooms) {
            return <span className="info">{options.bathrooms} bagni</span>
        }
        return <></>
    }

    function RoomInfo() {
        return options.featuresTeaser ? (
            <React.Fragment>
                {options.featuresTeaser.map((feature, i) => {
                    return (
                        feature.label && (
                            <span
                                className="info"
                                key={`label-` + feature.label}
                            >
                                {feature.label}
                            </span>
                        )
                    )
                })}
            </React.Fragment>
        ) : (
            <></>
        )
    }

    // -------------------------------------
    // Component local variables
    // -------------------------------------

    return (
        <div
            className={`${className} ${selected && "selected"}`}
            onClick={() => {
                allocateRoom(id)
            }}
        >
            <Row gutter={20}>
                <Col span={24} className="room">
                    <Image src={imageSrc} preview={false} />
                    <div className="info-wrapper">
                        <Title level={3}>{options.title}</Title>
                        <div>
                            <Mates />
                            <Rooms />
                            <Bathrooms />
                        </div>
                        <div>
                            <RoomInfo />
                        </div>
                        <div className="price">
                            <Text strong>{options.price}€</Text>
                            <Text> / mese</Text>
                        </div>
                    </div>
                </Col>
            </Row>
        </div>
    )
}

// ----------------------------------------------------------------------------
// Component PropTypes and default props
// ----------------------------------------------------------------------------

_RoomCard.propTypes = {
    className: PropTypes.string.isRequired,
    options: PropTypes.object,
    id: PropTypes.string,
    allocateRoom: PropTypes.func,
    selected: PropTypes.bool,
    imageSrc: PropTypes.any,
}

_RoomCard.defaultProps = {}

// ----------------------------------------------------------------------------

const RoomCard = styled(_RoomCard)`
    & {
        border-radius: ${(props) => props.theme.spacing.radius};
        box-shadow: 0px 4px 24px rgba(0, 0, 0, 0.07);
        overflow: hidden;
        cursor: pointer;
        border: 5px solid transparent;
        transition: border 200ms ease;
        &:hover {
            opacity: 0.8;
        }
        &.selected {
            border: 5px solid ${({ theme }) => theme.colors.success};
        }
        .ant-image {
            position: relative;
            width: 100%;
            padding-top: 50%;
            img {
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                object-fit: cover;
            }
        }
        .info-wrapper {
            padding: ${(props) => props.theme.spacing.smallPadding}
                ${(props) => props.theme.spacing.padding};
            h3 {
                font-size: ${(props) => props.theme.font.medium.size};
                line-height: ${(props) => props.theme.font.medium.height};
            }
            .info {
                font-size: ${(props) => props.theme.font.small.size};
                font-weight: ${(props) => props.theme.font.weight.regular};
                line-height: ${(props) => props.theme.font.small.height};
                color: ${(props) => props.theme.colors.dark500};
                &::after {
                    content: " · ";
                    display: inline;
                }
                &:last-child {
                    &::after {
                        display: none;
                    }
                }
            }
            .price {
                font-size: ${(props) => props.theme.font.medium.size};
                line-height: ${(props) => props.theme.font.medium.height};
                padding-top: ${(props) => props.theme.spacing.padding};
            }
        }
    }
`
// ----------------------------------------------------------------------------

export default RoomCard
